import { FormCard, FormItem, MultiSelect } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useGroupedCarers } from 'hooks/useGroupedOptions'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import type { ModalSectionProps } from '../utils'

type AllocationSectionProps = ModalSectionProps

export const AllocationSection: FC<AllocationSectionProps> = ({ formData }) => {
  const { t } = useTranslation()
  const { groupedCarerOptions } = useGroupedCarers()

  const teamMembersCount = formData?.teamMembers?.length ?? 0
  const maxTeamMembers = formData?.numberSupply ?? 0

  return (
    <FormCard level={2} title={t('ASSIGN_TEAM_MEMBER')}>
      <FormItem
        name="teamMembers"
        label={<Text>{t('TEAM_MEMBER(S)')}</Text>}
        short
      >
        <MultiSelect
          title={t('SELECT_TEAM_MEMBERS')}
          groupedOptions={groupedCarerOptions}
          hasClear
          hasSearch
          hasSelectAll
          values={formData?.teamMembers}
          placeholder
          maxTagCount={null}
          suffixIcon={
            <Text>
              {teamMembersCount}/{maxTeamMembers}
            </Text>
          }
        />
      </FormItem>
    </FormCard>
  )
}
